webpackJsonp([120942155054859],{

/***/ 69:
/***/ (function(module, exports) {

	"use strict";
	/** PYTANIA DO FAQ */
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ZAKLADANIE_SPOLEK_PAGE_FAQ_QUESTIONS = [{
	    elementQuestion: "1. Ile trwa założenie spółki zoo?",
	    elementAnswer: "W zależności od regionu Polski, procedura założenia spółki w systemie S24 od jej rozpoczęcia do momentu wpisu w KRS trwa zazwyczaj od 6 do 10 dni roboczych."
	}, {
	    elementQuestion: "2. Czy można otrzymać fakturę za usługę założenia spółki zoo?",
	    elementAnswer: "Tak, za przeprowadzenie rejestracji spółki otrzymują Państwo fakturę VAT."
	}, {
	    elementQuestion: "3. Czy otrzymaną fakturę można wliczyć w koszty?",
	    elementAnswer: "Tak, otrzymaną fakturę można wliczyć w koszty uzyskania przychodu."
	}, {
	    elementQuestion: "4. Kto może być udziałowcem w firmie?",
	    elementAnswer: ["W przypadku mikro sp. z o.o., patrząc z perspektywy uproszczeń rozliczeniowych i podatkowych, najkorzystniejszym przypadkiem jest gdy udziałowcem jest osoba fizyczna.", "Więcej informacji można odleźć również dziale II pkt 1 wpisu na naszej bazie wiedzy."],
	    elementButtonLinkTo: "https://pomoc.fakturomania.pl/support/solutions/articles/36000307874-czym-jest-sp-z-o-o-oraz-jak-j%C4%85-zorganizowa%C4%87-informacje-og%C3%B3lne"
	}, {
	    elementQuestion: "5. Co z ZUS?",
	    elementAnswer: "Wspólnicy spółki z o.o., której struktura właścicielska jest dwu lub ponad dwuosobowa, nie podlegają ZUS. Dany stan rzeczy wynika z braku objęcia obowiązkiem ZUS wspólników w art. 8 ust. 6 ustawy o systemie ubezpieczeń społecznych."
	}, {
	    elementQuestion: "6. Gdzie może być siedziba firmy?",
	    elementAnswer: "Siedzibą spółki jest miejscowość. Siedziba spółki może znajdować się w miejscu  zamieszkania - w domu, w lokalu w mieszkaniu, ale też w przestrzeniach wynajmowanych."
	}, {
	    elementQuestion: "7. Jakie są obowiązki związane z rejestracją spółki z o.o.??",
	    elementAnswer: ["Wraz z rejestracją podmiotu niezbędne jest przygotowanie dokumentacji składanej do Urzędu Skarbowego. Co do zasady są to następujące dokumenty: NIP-8, PCC-3 oraz ewentualnie VAT-R w przypadku rejestracji podmiotu w rejestrze VAT jako \"czynny podatnik VAT\" albo dla celów VATu europejskiego. ", "Niezbędne jest również przygotowanie umowy najmu lokalu oraz zgłoszenie spółki do CRBR."],
	    elementButtonLinkTo: "https://pomoc.fakturomania.pl/support/solutions/articles/36000278880-najem-lokalu-dla-sp%C3%B3%C5%82ki-z-o-o-"
	}];
	exports.CENNIK_PAGE_FAQ_QUESTIONS = [{
	    elementQuestion: "1. Czy możliwe jest przetestowanie aplikacji przed wykupieniem płatnego pakietu?",
	    elementAnswer: "Tak, każdy Użytkownik może skorzystać z bezpłatnego miesięcznego okresu testowego. Oznacza to, że przez miesiąc Użytkownik może bezpłatnie korzystać z pełnej funkcjonalności aplikacji."
	}, {
	    elementQuestion: "2. Co się dzieje po wygaśnięciu okresu testowego?",
	    elementAnswer: "Po wygaśnięciu okresu testowego konto przechodzi w stan spoczynku. Oznacza to, że jego funkcjonalność zostaje zredukowana jedynie do bezpłatnej funkcjonalności, którą jest wystawianie faktur sprzedażowych."
	}, {
	    elementQuestion: "3. Czy płatny pakiet umożliwia samodzielne prowadzenie pełnej księgowości online?",
	    elementAnswer: ["Tak, każdy pakiet premium wystarcza do prowadzenia pełnej księgowości online mikro sp. z o.o. Niniejsze narzędzie umożliwia bardzo łatwe rozliczenie niewielkich podmiotów sp. z o.o. których działąlność występuje na terytorium Rzeczypospolitej o charakterze usługowym lub handlowym", "Ponad 95% Podatników prowadzących swoje rozliczenie w księgowości Fakturomanii to mali podatnicy, których statystyczne rozliczenie oscyluje w granicach do 30 dokumentów w ujęciu miesięcznym. Z tego względu księgowość z Fakturomanią jest optymalizowana właśnie pod kątem takiej wielkości działalności, tak aby każdy mógł w sposób przystępny i prosty rozliczyć taką mikro sp. z o.o.", "System nie jest jednak odpowiedni dla działalności o charakterze produkcyjnym, deweloperskim, transgranicznym lub inwestycyjnym. Z uwagi też na dedykację dla podstawowego obrotu krajowego, w systemie nie są wspierane transakcje o charakterze walutowym lub przynależnym do zysków kapitałowych (np. inwestycje w obrót kryptowalutami, papierami wartościowymi, akcjami, udziałami, zyskami z osób prawnych - przychodów, o których mowa m.in. w art. 7b ustwawy z dnia 15 lutego 1992 o podatku dochodowym od osób prawnych).", "System nie jest również odpowiedni dla podmiotów, które posiadają udziały w innych osobach prawnych lub wspólnikami są osoby prawne, lub w których występują transakcje transgraniczne w tym podlegające procedurze OSS lub IOSS za wyjątkiem sporadycznych transakcji zakupowych WNT lub importu usług. Taki typ działalności warto jest powierzyć prowadzeniu przez biuro rachunkowe z uwagi na jego znaczne skomplikowanie."]
	}, {
	    elementQuestion: "4. Co się dzieje po wygaśnięciu pakietu płatnego?",
	    elementAnswer: "Po wygaśnięciu pakietu płatnego funkcjonalność konta zostaje ograniczona do przeglądania wygenerowanych uprzednio dokumentów oraz konto zamienia się w konto dla bezpłatnej funcjonalności."
	}, {
	    elementQuestion: "5. Czy dla Użytkownika jest możliwość uzyskania pomocy księgowego?",
	    elementAnswer: "W przypadku zdecydowania się na korzystanie z Fakturomanii, w godzinach od 10 do 16, w przypadku pytań lub wątpliwości nasi księgowi są do Państwa dyspozycji. Jeżeli zatem pojawiają się pytania dotyczące aplikacji, księgowości lub spółek zoo - zachęcamy do kontaktu przez czat, mailowo lub telefonicznie, zawsze udzielamy Państwu wsparcia."
	}, {
	    elementQuestion: "6. Czy dostęp do doradcy księgowego zawiera się w pakiecie bezpłatnym?",
	    elementAnswer: "W przypadku pakietu bezpłatnego zespół wsparcia Fakturomanii zawsze udzieli Państwu pomocy z zakresu obsługi technicznej aplikacji."
	}, {
	    elementQuestion: "7. Czy jeśli wykupię dostęp do aplikacji, będę związany umową na czas określony? Czy są jakieś kary umowne lub odsetki?",
	    elementAnswer: "Wykupienie dostępu do aplikacji skutkuje zawiązaniem umowy drogą elektroniczną na czas oznaczony odpowiadający wybranemu pakietowi. Brak jest kar umownych lub odsetek, w każdej chwili mogą Państwo zrezygnować z usług serwisu Fakturomania. W przypadku rezygnacji z serwisu kwota za niewykorzystany czas abonamentu nie podlega jednak zwrotowi."
	}, {
	    elementQuestion: "8. Czy aplikacja Fakturomanii jest skierowana do działalności gospodarczej osób fizycznych?",
	    elementAnswer: ["Aplikacja Fakturomanii jest dedykowana wyłącznie dla osób prawnych - mikro sp. z o.o."]
	}];
	exports.FAQ_PAGE_FAQ_QUESTIONS = [{
	    elementQuestion: "1. Czym jest Fakturomania?",
	    elementAnswer: ["Fakturomania to aplikacja webowa służąca prowadzeniu pełnej księgowości online.", "Nasze rozwiązanie skierowane jest do mikro spółek z ograniczoną odpowiedzialnością prowadzących działalność gospodarczą na terytorium Polski.", "Jeśli chcesz prowadzić własną firmę, ale obawiasz się wysokich kosztów związanych z jej prowadzeniem – Fakturomania może być dobrym rozwiązaniem."]
	}, {
	    elementQuestion: "2. Czym jest pełna księgowość online?",
	    elementAnswer: "Pełna księgowość to rozbudowany, precyzyjny i dokładny system ewidencji zdarzeń gospodarczych, będący częścią Rachunkowości. Służy on do kontroli, analizy i generowania informacji na temat sytuacji firmy w danym momencie lub na przestrzeni pewnego okresu."
	}, {
	    elementQuestion: "3. Czy Fakturomania wymaga specjalistycznej wiedzy księgowej?",
	    elementAnswer: ["Nie, rozliczenia w Fakturomanii nie wymagają posiadania specjalistycznej wiedzy księgowej. Do korzystania z aplikacji wystarczy połączenie z internetem, przeglądarka internetowa, systematyczność oraz skrupulatność.", "Obsługa aplikacji została na tyle uproszczona, aby każdy był w stanie poprowadzić pełną księgowość mikro spółek zoo. W razie jakichkolwiek wątpliwości zawsze służymy pomocą.", "Fakturomania to również bogata baza wiedzy omawiająca zagadnienia związane z księgowością, podatkami i samą spółką z o.o."]
	}, {
	    elementQuestion: "4. Dla kogo przeznaczona jest aplikacja?",
	    elementAnswer: "Aplikacja jest dedykowana jednostkom mikro, które prowadzą działalność w formie spółki z o.o. o profilu usługowym, handlowym lub usługowo-handlowym na terytorium Polski."
	}, {
	    elementQuestion: "5. Ile można zyskać, prowadząc firmę w formie spółki z o.o.?",
	    elementAnswer: ["Dzięki spółce z o.o. zyskać można bardzo wiele, zarówno pod względem znaczącego ograniczenia odpowiedzialności jak i też pod względem oszczędności.", "Kwota oszczędności wynosić może od kilku do nawet kilkudziesięciu tysięcy złotych rocznie - w przypadku optymalnego zaplanowania działaności."]
	}, {
	    elementQuestion: "6. Co z ZUS?",
	    elementAnswer: "W sytuacji gdy wspólników w spółce jest co najmniej dwóch, to żaden z nich nie podlega obowiązkowi ubezpieczeń społecznych oraz zdrowotnych. Decyzja o dobrowolnym ubezpieczeniu należy do przedsiębiorcy."
	}, {
	    elementQuestion: "7. Co z polityką rachunkowości oraz planem kont?",
	    elementAnswer: "Dla Państwa wygody przygotowany został uniwersalny plan kont oraz polityka rachunkowości, które są generowane automatycznie przez aplikację. Dokumenty te wystarczy wydrukować i podpisać."
	}];

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  margin-top: -20px;\n  padding-top: 0px !important;\n  padding-bottom: 40px !important;\n"], ["\n  ", "\n  ", "\n  margin-top: -20px;\n  padding-top: 0px !important;\n  padding-bottom: 40px !important;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var gatsby_link_1 = __webpack_require__(36);
	var styled_components_1 = __webpack_require__(2);
	var googleAnalyticsService = __webpack_require__(9);
	
	var ActionButtonBlock = function (_React$Component) {
	    _inherits(ActionButtonBlock, _React$Component);
	
	    function ActionButtonBlock(props) {
	        _classCallCheck(this, ActionButtonBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        _this.onButtonClick = _this.onButtonClick.bind(_this);
	        return _this;
	    }
	
	    ActionButtonBlock.prototype.onComponentView = function onComponentView() {
	        if (this.props.componentViewEventType) {
	            googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	        }
	    };
	
	    ActionButtonBlock.prototype.onButtonClick = function onButtonClick() {
	        if (this.props.buttonClickEventType) {
	            googleAnalyticsService.trackEvent(this.props.buttonClickEventType);
	        }
	    };
	
	    ActionButtonBlock.prototype.render = function render() {
	        var _props = this.props,
	            actionButtonIntro = _props.actionButtonIntro,
	            actionButtonText = _props.actionButtonText,
	            actionButtonLinkTo = _props.actionButtonLinkTo;
	
	        return React.createElement("div", { className: "materialize-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(ActionButtonBlockWrapper, { className: "section-padding", marginTop: this.props.marginTop, marginBottom: this.props.marginBottom }, React.createElement("div", { className: "container" }, React.createElement("div", { className: "text-center mt-40" }, React.createElement("h2", { className: "mb-30 text-uppercase" }, actionButtonIntro), React.createElement(gatsby_link_1.default, { to: actionButtonLinkTo, className: "btn btn-lg waves-effect waves-light", onClick: this.onButtonClick }, actionButtonText)))));
	    };
	
	    return ActionButtonBlock;
	}(React.Component);
	/** STYLES => FaqBlock */
	
	
	var ActionButtonBlockWrapper = styled_components_1.default.section(_templateObject, function (props) {
	    return typeof props.marginTop === 'number' && "margin-top: " + props.marginTop + "px !important;";
	}, function (props) {
	    return typeof props.marginBottom === 'number' && "margin-bottom: " + props.marginBottom + "px !important;";
	});
	exports.default = ActionButtonBlock;

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background-image: none !important;\n"], ["\n  background-image: none !important;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  line-height: 17.6px !important;\n"], ["\n  line-height: 17.6px !important;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n"], ["\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  margin-top: -20px;\n  padding-top: 0px !important;\n  padding-bottom: 40px !important;\n"], ["\n  margin-top: -20px;\n  padding-top: 0px !important;\n  padding-bottom: 40px !important;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"]);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var googleAnalyticsService = __webpack_require__(9);
	var styled_components_1 = __webpack_require__(2);
	var FaqBlockElement = function FaqBlockElement(props) {
	    var activeElementIndex = props.activeElementIndex,
	        elementIndex = props.elementIndex,
	        selectElement = props.selectElement,
	        elementQuestion = props.elementQuestion,
	        elementAnswer = props.elementAnswer,
	        elementButtonLinkTo = props.elementButtonLinkTo;
	
	    var isActive = activeElementIndex == elementIndex;
	    // SPRAWDZANIE CZY OPIS JEST LISTĄ
	    var elementAnswerIsAList = Array.isArray(elementAnswer);
	    // ZWRACANIE DANYCH
	    return React.createElement("div", { className: "panel panel-default" }, React.createElement(PanelHeadingWrapper, { className: "panel-heading", onClick: function onClick() {
	            return selectElement(elementIndex);
	        } }, React.createElement(PanelTitleWrapper, { className: "panel-title" }, React.createElement("a", null, elementQuestion))), React.createElement("div", { className: "panel-collapse collapse in" }, React.createElement(PanelBodyWrapper, { className: "panel-body" }, !elementAnswerIsAList && elementAnswer, elementAnswerIsAList && elementAnswer.map(function (answerPart, i) {
	        return React.createElement("div", { key: i, className: "answer-part" }, answerPart);
	    }), elementButtonLinkTo && React.createElement("a", { href: elementButtonLinkTo, target: "_blank", className: "btn btn-sm waves-effect waves-light mt-20" }, "Wi\u0119cej"))));
	};
	/** STYLES => FaqBlockElement */
	var PanelHeadingWrapper = styled_components_1.default.div(_templateObject);
	var PanelTitleWrapper = styled_components_1.default.h3(_templateObject2);
	var PanelBodyWrapper = styled_components_1.default.div(_templateObject3);
	
	var FaqBlock = function (_React$Component) {
	    _inherits(FaqBlock, _React$Component);
	
	    function FaqBlock(props) {
	        _classCallCheck(this, FaqBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            activeElementIndex: 1
	        };
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        _this.onFaqQuestionSelect = _this.onFaqQuestionSelect.bind(_this);
	        return _this;
	    }
	
	    FaqBlock.prototype.onComponentView = function onComponentView() {
	        if (this.props.componentViewEventType) {
	            googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	        }
	    };
	
	    FaqBlock.prototype.onFaqQuestionSelect = function onFaqQuestionSelect(index) {
	        // ZAZNACZANIE I ODZNACZANIE
	        var activeElementIndex = this.state.activeElementIndex;
	
	        if (index == activeElementIndex) {
	            this.setState({ activeElementIndex: 0 });
	        } else {
	            this.setState({ activeElementIndex: index });
	        }
	        // GOOGLE EVENT
	        if (this.props.faqQuestionReadEventType) {
	            googleAnalyticsService.trackEvent(this.props.faqQuestionReadEventType);
	        }
	    };
	
	    FaqBlock.prototype.render = function render() {
	        var _this2 = this;
	
	        var faqQuestions = this.props.faqQuestions;
	        var activeElementIndex = this.state.activeElementIndex;
	
	        return React.createElement("div", { className: "materialize-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(FaqBlockWrapper, { className: "section-padding" }, React.createElement("div", { className: "container" }, React.createElement(FaqBlockElementsWrapper, { className: "row" }, React.createElement("div", { className: "col-lg-9 col-md-12 col-sm-12 col-xs-12" }, React.createElement("div", { className: "panel-group flat-accordion brand-accordion z-depth-1" }, faqQuestions.map(function (faqQuestion, index) {
	            return React.createElement(FaqBlockElement, _extends({ key: index, activeElementIndex: activeElementIndex, elementIndex: index + 1, selectElement: _this2.onFaqQuestionSelect }, faqQuestion));
	        })))))));
	    };
	
	    return FaqBlock;
	}(React.Component);
	/** STYLES => FaqBlock */
	
	
	var FaqBlockWrapper = styled_components_1.default.section(_templateObject4);
	var FaqBlockElementsWrapper = styled_components_1.default.div(_templateObject5);
	exports.default = FaqBlock;

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_helmet_1 = __webpack_require__(23);
	var breadcrumbs_block_1 = __webpack_require__(42);
	var title_block_1 = __webpack_require__(43);
	var faq_block_1 = __webpack_require__(75);
	var action_button_block_1 = __webpack_require__(134);
	var google_analytics_1 = __webpack_require__(34);
	var types_1 = __webpack_require__(14);
	var faqQuestionsData = __webpack_require__(69);
	var staticUrls = __webpack_require__(17);
	var helmetData = __webpack_require__(21);
	var cacheBustingService = __webpack_require__(26);
	
	var FaqPage = function (_React$Component) {
	    _inherits(FaqPage, _React$Component);
	
	    function FaqPage() {
	        _classCallCheck(this, FaqPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    FaqPage.prototype.componentDidMount = function componentDidMount() {
	        cacheBustingService.handleCacheBusting(caches);
	    };
	
	    FaqPage.prototype.render = function render() {
	        return React.createElement("div", null, React.createElement(react_helmet_1.Helmet, _extends({}, helmetData.prepareHelmetData(types_1.PageType.FaqPage))), React.createElement(breadcrumbs_block_1.default, { breadcrumbsElement: {
	                elementName: "FAQ",
	                elementDescription: ""
	            } }), React.createElement(title_block_1.default, { firstLineBlackStart: "Najczęściej zadawane", firstLineBlue: "pytania", firstLineBlackEnd: "", secondLineText: "Zapoznaj się z odpowiedziami na najczęściej zadawane pytania." }), React.createElement(faq_block_1.default, { faqQuestions: faqQuestionsData.FAQ_PAGE_FAQ_QUESTIONS, componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.FaqPageViewedFaqBlock, faqQuestionReadEventType: google_analytics_1.GoogleAnalyticsEventType.FaqPageViewedFaqBlockQuestion }), React.createElement(action_button_block_1.default, { actionButtonIntro: "Masz więcej pytań? Skontaktuj się z nami!", actionButtonText: "KONTAKT", actionButtonLinkTo: staticUrls.FAKTUROMANIA_KONTAKT_PAGE_URL, componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.FaqPageViewedDetailsBlock, buttonClickEventType: google_analytics_1.GoogleAnalyticsEventType.FaqPageClickedCTAAtDetailsBlock }));
	    };
	
	    return FaqPage;
	}(React.Component);
	
	exports.default = FaqPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-faq-tsx-cfdbebbb38246405c2f4.js